import jsmediatags from 'jsmediatags/dist/jsmediatags.min.js';

export const readAudioMetadata = (file) => {
  return new Promise((resolve) => {
    jsmediatags.read(file, {
      onSuccess: ({ tags }) => resolve(tags || {}),
      onError: () => resolve({}),
    });
  });
};

export const pictureToBlob = (picture) => {
  const bytes = new Uint8Array(picture.data);
  return new Blob([bytes], { type: picture.format || 'image/jpeg' });
};
